$(function() {
    $('.btn-toggle-menu').click(function(e) {

        $(this).toggleClass('active');
        
        $('.toggle-menu').slideToggle();
    });
});

jQuery(document).ready(function($) {
    $('#menu-menu-principal > li').not(':last-child').each(function() {
        $('<span class="main-menu_sep"></span>').insertAfter($(this));
    });
});
